import { Service } from '@toeverything/infra';

import type { DocCreateMiddleware, DocRecord } from '../doc';
import type { WorkspaceService } from '../workspace';
import type { DocCreationLocationService } from './service';

export class CreationLocationMiddleware
  extends Service
  implements DocCreateMiddleware
{
  constructor(
    private readonly location: DocCreationLocationService,
    private readonly workspaceService: WorkspaceService
  ) {
    super();
  }

  afterCreate(doc: DocRecord) {
    this.location
      .captureForDocs(this.workspaceService.workspace, [doc.id])
      .catch(() => {});
  }
}
